// extracted by mini-css-extract-plugin
export default {"emailIcon":"Email_emailIcon__5fF2t"};